<template>
  <div>
    <!-- Enquanto estiver carregando, você pode exibir um skeleton, spinner ou apenas ocultar -->
    <div v-if="carregando" class="text-center p-4">
      <i class="fa fa-spinner fa-spin fa-2x"></i> Carregando registros...
    </div>

    <!-- Só exibe o conteúdo ou o erro DEPOIS de carregar -->
    <template v-else>
      <section role="form" v-if="!estahVazio(registros)">
        <div class="main-container container container-top">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-default">
                <div class="card-content">
                  <h4>Atualização Cadastral por ano e mês</h4>
                  <div>
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Ano</th>
                          <th>Mês</th>
                          <th>Situação</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in registros" :key="item.id">
                          <td>{{ item.anoCompetencia }}</td>
                          <td>{{ item.mesCompetencia }}</td>
                          <td>{{ item.situacao }}</td>
                          <td>
                            <botao 
                              estilo="vazado-cinza-sm" 
                              icone="visualizar"  
                              v-tooltip.left="'Visualizar'"  
                              @clicado="visualizar(item.id)"></botao>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <pagina-erro
        v-else
        titulo="Atualização Cadastral Encerrada"
        icone="fa fa-hourglass-end"
        imagemTexto="centralservidor-logo-texto.png"
        imagem="centralservidor-logo.png"
        texto="O período de atualização cadastral se encerrou. Caso ainda precise atualizar seus dados, dirija-se ao DEGEPAT.">
      </pagina-erro>
    </template>
  </div>
</template>

<script>
import RecadastramentoService from '@/services/recadastramentoService';
import Botao from '@/components/botao';
import PaginaErro from '@/components/pagina-erro';

export default {
  name: 'MesCompetenciaOrdenado',

  data() {
    return {
      registros: [],
      carregando: true,
    };
  },

  async created() {
    await this.carregarRegistros();
  },

  methods: {
    async carregarRegistros() {
      this.carregando = true;
      try {
        const teste = await RecadastramentoService.listaPorAno();
        this.registros = await teste;
        if (this.estahVazio(this.registros)) {
          // Lógica para lidar com registros vazios, se necessário
        }

        if (this.registros.length > 0) {
          this.$store.dispatch('updateSituacaoRecad', this.registros[0].situacao);
        }

        this.carregando = false;
      } catch (error) {
        this.carregando = false;
        this.$root.$refs.toastr.e(error.message, 'Atenção');
      }
    },
    visualizar(id) {
      if(id) {
        sessionStorage.setItem('userId', id); 
        this.$router.push({ name: 'DadosPessoais', params: { id: id } });
      } else {
        console.error('ID inválido');
      }
     // this.$router.push({ name: 'DadosPessoais', params: { id: id } });
    },
    estahVazio(objeto) {
      for (let key in objeto) {
        if (objeto.hasOwnProperty(key)) return false;
      }
      return true;
    },
    volta() {
      this.$router.push({ name: 'OutraRota' });
    },
  },
  components: {
    Botao,
    PaginaErro,
  },
};
</script>

<style scoped>
/* Adicione estilos conforme necessário */
</style>



// WEBPACK FOOTER //
// index.vue?b21fe3c2